<div class="flex">
    <div class="upload pointer" (click)="(isNotUser$() && !isPreview)?null:openFile()" *ngIf="question?.imageBase64 else noFile">
        <img src="/assets/images/preview-eye.svg" />
        <p translate>questionBoard.edit.uploadFile.viewDocument</p>
    </div>
    <p class="text">{{question?.additionalText}}</p>
</div>
<ng-template #noFile>
    <span class="no-file" >no file</span>
</ng-template>